import { FC, useState } from 'react';
import { Box, FormLabel, IconButton, InputAdornment, OutlinedInput, Typography } from '@mui/material';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import styles from './CustomPassInput.module.scss';

type CustomPassInputProps = {
  customClass?: string;
  error?: string;
  name?: string;
  label: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
}

const CustomPassInput: FC<CustomPassInputProps> = ({customClass, error = '', name = 'password', label, onChange}) => {
  const [showPassword, setShowPassword] = useState(false);
  
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <Box id={styles.customInputContainer} className={customClass}>
      <FormLabel className={styles.customInputLabel}>
      <Typography variant='h11Semibold'>{label}</Typography>
      </FormLabel>
      <OutlinedInput
        type={showPassword ? 'text' : 'password'}
        name={name}
        required
        className={`${error && styles.error} ${styles.customInput}`}
        placeholder='Enter your password'
        onChange={onChange}
        endAdornment={
          <InputAdornment position="end">
          <IconButton
            aria-label={
            showPassword ? 'hide the password' : 'display the password'
            }
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            onMouseUp={handleMouseUpPassword}
            edge="end"
          >
            {!showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
          </IconButton>
          </InputAdornment>
        }
        label={label}
      />
      {error && <Typography variant='h11' className={styles.errorMessage}>{error}</Typography>}
    </Box>
  )
}

export default CustomPassInput;